import { render, staticRenderFns } from "./AppLoadingModal.vue?vue&type=template&id=3b500e57&"
import script from "./AppLoadingModal.vue?vue&type=script&lang=js&"
export * from "./AppLoadingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports